__webpack_require__.p = "//{{CDN_HOST}}/";